import React, { useEffect, useState } from "react";
import useTranslation from "../../../../hooks/use-translation";
import moment from "moment"

import lodash from "lodash";
import DetailsCard from "./Components/DetailsCard";
import QRCode from "./Components/QRCode";
import { useIsDesktop, useIsTablet } from '../../../../hooks/breakpoints';
import { vaccinationApiRequestBody } from '../../../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody';
import apiRequest from '../../../../utils/api.request';
import EditCowinDetails from "./Components/EditCowinDetails";
import config from "../../../../config.json";
import { parseQueryString } from '../../../../utils/utils';
import useBoolean from "../../../../hooks/use-boolean";
import Dialog from "../../../Dialog-box";
import qrIcon from "../../../../images/qrIcon.svg";

import backArrowImage from "../../../../images/cowinBackArrow.svg";

import "./ViewAppointmentDetails.css";

const sampleEmptyDetails = {
  firstRow: [],
  secondRow: []
}

const ViewAppointmentDetails = ({ appointmentDetails, _backClick = () => { }, handleYesClick, rescheduleClick, setStep }) => {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();
  const [showEditDetails, _setshowEditDetails] = useState(false);
  const [showQR, _setshowQR] = useState(false);
  const [error, _setError] = useState("");
  const [userData, _setUserData] = useState(sampleEmptyDetails);
  const [cowinData, _setCowinData] = useState(sampleEmptyDetails);
  const [appointmentData, _setAppointmentData] = useState(sampleEmptyDetails);
  const [qrData, _setQrData] = useState({ name: "", bookedDate: "", value: "" });
  const [editCowinDetails, _setEditCowinDetails] = useState({ name: "", mobile: "", refId: "" });
  const [showCowinDetails, _setShowCowinDetails] = useState(false);
  const [isOpen, open, close] = useBoolean();
  const queryParams = parseQueryString();

  const updateCowinInfoUrl = config.covid_vacc_base_url + "booking/v2/updatecowininfo/"

  useEffect(() => {
    _getUserData();
    _getCowinData(lodash.get(appointmentDetails, "cowin_details"));
    _getAppointmentData();
    _getQrData();
  }, [])

  const _getUserData = () => {
    let userName = lodash.get(queryParams, "t", "");
    try {
      userName = atob(userName)
    }
    catch (e) { userName = "" }
    const userGender = lodash.get(queryParams, "source_gender", "");
    const userAge = lodash.get(queryParams, "source_age_years", "");
    const newUserData = {
      firstRow: [
        { id: 1, title: t("NAME"), text: userName }
      ],
      secondRow: [
        { id: 1, title: t("GENDER"), text: userGender },
        { id: 2, title: t("AGE"), text: userAge },
      ]
    }
    _setUserData(newUserData);
  }

  const _getCowinData = (data) => {
    const newEditCowinDetails = {
      name: lodash.get(data, "name", ""),
      mobile: lodash.get(data, "mobile_number", ""),
      refId: lodash.get(data, "beneficiary_id", ""),
    }
    const newCowinData = {
      firstRow: [
        { id: 1, title: t("COWIN_NAME"), text: newEditCowinDetails.name }
      ],
      secondRow: [
        { id: 1, title: t("COWIN_MOBILE"), text: newEditCowinDetails.mobile },
        { id: 2, title: t("COWIN_REF_ID"), text: newEditCowinDetails.refId },
      ]
    }
    if (newEditCowinDetails.name.length || newEditCowinDetails.mobile.length || newEditCowinDetails.refId.length) {
      _setShowCowinDetails(true);
    } else {
      _setShowCowinDetails(false);
    }
    _setCowinData(newCowinData);
    _setEditCowinDetails(newEditCowinDetails);
  }

  const _getAppointmentData = () => {
    const newAppointmentData = {
      firstRow: [
        { id: 1, title: t("APPOINTMENT_DATE"), text: moment(new Date(lodash.get(appointmentDetails, "booked_appointment_date"))).format("DD-MMMM-YYYY, hh:mm a") }
      ],
      secondRow: [
        { id: 1, title: t("CENTRE"), text: lodash.get(appointmentDetails, "hosiptal_details.name", "") },
        { id: 2, title: t("APPOINTMENT_ID"), text: lodash.get(appointmentDetails, "appointment_id", "") },
        { id: 3, title: t("STATUS"), text: lodash.get(appointmentDetails, "appointment_status.status_message", "") },
      ]
    }
    _setAppointmentData(newAppointmentData);
  }

  const _getQrData = () => {
    let userName = lodash.get(queryParams, "t", "");
    try {
      userName = atob(userName)
    }
    catch (e) { userName = "" }
    const newQrData = {
      name: userName,
      bookedDate: moment(new Date(lodash.get(appointmentDetails, "booked_appointment_date"))).format("DD/MM/YYYY hh:mm a"),
      value: lodash.get(appointmentDetails, "qr_code", "")
    }
    _setQrData(newQrData);
  }

  const _updateCowinDetails = async (newName, newMobile, newRefId) => {
    const auth_token = lodash.get(queryParams, "auth_token");
    const source_id = lodash.get(queryParams, "source_id").toLowerCase();
    const source_user_id = lodash.get(queryParams, "source_user_id");
    const source_relation = lodash.get(queryParams, "source_relation");
    const source_user_relation_id = lodash.get(queryParams, "source_user_relation_id");
    const userDetailsObj = {
      auth_token,
      source_id,
      source_user_id,
      source_relation,
      source_user_relation_id
    }
    const orderId = lodash.get(appointmentDetails, "order_id");
    const dataObj = vaccinationApiRequestBody({ order_id: orderId, cowin_mobile_no: newMobile, cowin_name: newName, reference_id: newRefId }, userDetailsObj)

    const response = await apiRequest(updateCowinInfoUrl, dataObj, true);
    if (lodash.get(response, "status") !== "success") {
      _setError(lodash.get(response, "response.data.message", "Something went wrong. Please try again."));
      return;
    }
    const newData = {
      name: newName,
      mobile_number: newMobile,
      beneficiary_id: newRefId
    }
    _getCowinData(newData);
    _setError("");
    _setshowEditDetails(false);
  }

  const handleYesButton = (order_id) => {
    close();
    handleYesClick(order_id);
    setStep(1);
  };

  return <div className="view-appointment-details-div">
    {!showQR &&
      <div className="view-appointment-details-header" onClick={_backClick}>
        <img src={backArrowImage} className="view-appointment-details-header-back-image" />
        <span className="view-appointment-details-header-back-text">{t("GO_BACK")}</span>
      </div>
    }
    {!(isDesktop || isTablet) && !showQR &&
      <div type="button" className="show-qr-button-mobile" onClick={() => _setshowQR(true)} >
        <img src={qrIcon} alt="qr-icon" />
        {t("SHOW_QR_CODE")}
      </ div>
    }
    <div className="view-appointment-details-body">
      <div className={showQR === true ? "modal-open" : "view-appointment-details-cards"}>
        <DetailsCard header="User Details" details={userData} />
        <br />
        {showCowinDetails &&
          <>
            <DetailsCard showHeaderButton={lodash.get(appointmentDetails, "can_edit", false)} _headerButtonClick={() => { _setshowEditDetails(true) }} header="Co-WIN registration details" details={cowinData} />
            <br />
          </>
        }
        <DetailsCard header="Appointment details" details={appointmentData} />
        <br />
        <div className="view-appointment-details-buttons-div">
          {lodash.get(appointmentDetails, "can_cancel", false) &&
            <div className="view-appointment-details-button" onClick={open}>
              {t("CANCEL")}
            </div>
          }
          {lodash.get(appointmentDetails, "can_reschedule", false) &&
            <div className="view-appointment-details-button" onClick={() => rescheduleClick(appointmentDetails)}>
              {t("RESCHEDULE_BUTTON")}
            </div>
          }
        </div>
        <Dialog
          open={isOpen}
          dialogType="cancelappointment"
          handleDialogOk={() => handleYesButton(appointmentDetails?.order_id)}
          handleCancel={close}
        />
        {showEditDetails &&
          <>
            <div className="edit-details-modal-overlay" onClick={() => { _setshowEditDetails(false); _setError("") }} />
            <div className="edit-details-modal-body">
              <EditCowinDetails cowinName={editCowinDetails.name} cowinMobile={editCowinDetails.mobile} cowinRefId={editCowinDetails.refId} _cancelClick={() => { _setshowEditDetails(false) }} _saveClick={_updateCowinDetails} apiError={error} _setApiError={_setError} />
            </div>
          </>
        }
      </div>
      <div className="view-appointment-details-qr">
        {!(isDesktop || isTablet) && showQR &&
          <QRCode qrData={qrData} onBackClick={_setshowQR} />
        }
        {(isDesktop || isTablet) &&
          <QRCode qrData={qrData} />
        }
      </div>
    </div>
  </div>
}

export default ViewAppointmentDetails;